import React, { useState, useEffect, useMemo } from "react";
import { Card } from "antd";
import GetFormComponent from "../GetFormComponent";

function PreviewApplicationView({ formPreviewData }) {
  const [previewData, setPreviewData] = useState([]);

  useEffect(() => {
    const results = filterChildElements(formPreviewData);
    setPreviewData(results);
  }, [formPreviewData]);

  const filterChildElements = (elementsArray) => {
    let arrr = [];

    for (let item of elementsArray) {
      if (item === null) {
        continue;
      } else {
        if (item?.type === "select" || item?.type === "radio") {
          for (let i = 0; i < item?.parent?.length; i++) {
            arrr.push(item?.parent[i]?.child?.id);
          }
        }
      }
    }

    const results = elementsArray.filter(
      (ele) => ele != null && !arrr.some((index) => index === ele.id)
    );

    return results;
  };

  return (
    <div>
      {previewData &&
        previewData?.map((element, key) => {
          element.editable = true
          return <GetFormComponent isPreview={true} element={element} key={key} formError="" />;
        })}
    </div>
  );
}

export default PreviewApplicationView;
